import React from "react";
import TextField from "@material-ui/core/TextField";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";

// Buyer (Aranan) ilan: kabul edilen kat sayısı aralığı (katSayisiMin - katSayisiMax).
// Redux: newAdvert.filters.katSayisiMin, newAdvert.filters.katSayisiMax.
function FLBuyerKatSayisiRange(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const min = filters?.katSayisiMin ?? "";
  const max = filters?.katSayisiMax ?? "";

  return (
    <div style={{ display: "flex", gap: 8, width: "100%" }}>
      <TextField
        type="number"
        label="En Az Kat Sayısı"
        variant="outlined"
        margin="dense"
        fullWidth
        value={min}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "katSayisiMin",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 0 }}
      />
      <TextField
        type="number"
        label="En Çok Kat Sayısı"
        variant="outlined"
        margin="dense"
        fullWidth
        value={max}
        onChange={(e) =>
          props.editNewAdvertFilters(
            "katSayisiMax",
            e.target.value === "" ? "" : Number(e.target.value)
          )
        }
        inputProps={{ min: 0 }}
      />
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(FLBuyerKatSayisiRange);
